import { render, staticRenderFns } from "./newSubmit.vue?vue&type=template&id=fea56cca&scoped=true&"
import script from "./newSubmit.vue?vue&type=script&lang=js&"
export * from "./newSubmit.vue?vue&type=script&lang=js&"
import style0 from "./newSubmit.vue?vue&type=style&index=0&id=fea56cca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea56cca",
  null
  
)

export default component.exports